/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_ChatInputs */

const en_mk_nav_p_chat = /** @type {(inputs: Mk_Nav_P_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team chat`)
};

const id_mk_nav_p_chat = /** @type {(inputs: Mk_Nav_P_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat tim`)
};

/**
* | output |
* | --- |
* | "Team chat" |
*
* @param {Mk_Nav_P_ChatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_chat = /** @type {((inputs?: Mk_Nav_P_ChatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_ChatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_chat(inputs)
	return en_mk_nav_p_chat(inputs)
});